import * as React from 'react';
import { TableHead, TableRow, TableCell, TableSortLabel, Checkbox, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { PaginatedTableColumn, Order } from './';

interface PaginatedTableHeadProps {
  columns: PaginatedTableColumn[];
  onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  order: Order;
  orderBy: string;
  numSelected: number;
  rowCount: number;
  showCheckbox?: boolean;
  selectionMode?: 'multiple' | 'single';
  boxedCells?: boolean;
  boxedCellClass?: string;
}

const PaginatedTableHead: React.FC<PaginatedTableHeadProps> = (props) => {
  const { columns, onSelectAllClick, order, orderBy, onRequestSort, numSelected, rowCount, showCheckbox, selectionMode, boxedCells = false, boxedCellClass = '' } = props;
  const theme = useTheme();
  
  const createSortHandler = (property: string) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox" sx={{ backgroundColor: theme.palette.background.default, padding: '4px 6px' }} className={boxedCells ? boxedCellClass : undefined}>
          <Checkbox
            color="secondary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all items' }}
          />
        </TableCell>
        {columns.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ 
              backgroundColor: theme.palette.background.default, 
              color: theme.palette.text.secondary, 
              fontWeight: 500,
              fontSize: '0.95rem', // smaller font
              borderBottom: `1px solid ${theme.palette.divider}`,
              padding: '4px 8px', // reduced padding
            }}
            className={boxedCells ? boxedCellClass : undefined}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              sx={{
                '&.MuiTableSortLabel-root:hover': {
                  color: theme.palette.primary.main,
                },
                '&.Mui-active': {
                  color: theme.palette.primary.main,
                }
              }}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={{ display: 'none' }}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default PaginatedTableHead;
